
import dashboard from './dashboard'
import contact from './contact'
import senderId from './sender-id'
import billing from './billing'
import message from './message'
// import voice from './voice'
import developer from './developer'

export default [
  ...dashboard,
  ...message,
  // ...voice,
  ...billing,
  ...senderId,
  ...contact,
  ...developer,
]
